import {
    AMEX_CARD_MASK,
    OTHER_CARD_MASK,
    MAESTRO_CARD_MASK
} from '../constants/card-masks';
import { CARD_TYPES } from '../constants/card-types-constants';

function getCardMaskByCardType(cardType = '') {
    let cardMask = OTHER_CARD_MASK;
    if (cardType === CARD_TYPES.AMEX) {
        cardMask = AMEX_CARD_MASK;
    } else if (cardType === CARD_TYPES.MAESTRO) {
        cardMask = MAESTRO_CARD_MASK;
    }
    return cardMask;
}

export {
    getCardMaskByCardType
}
